import { render } from "./RelationshipResearchStatus.vue?vue&type=template&id=b2ceb290&scoped=true"
import script from "./RelationshipResearchStatus.vue?vue&type=script&lang=js"
export * from "./RelationshipResearchStatus.vue?vue&type=script&lang=js"

import "./RelationshipResearchStatus.vue?vue&type=style&index=0&id=b2ceb290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ceb290"]])

export default __exports__